import { matchesProduct, sizeOrder } from './everytee-catalog-model.js';

class EveryteeCatalog extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.cards = [...this.querySelectorAll('[data-catalog-card]')].map(element => ({
      element, data: JSON.parse(element.querySelector('[data-filter-data]').textContent),
    }));
    this.form = this.querySelector('[data-filters]');
    for (const field of ['color', 'size']) {
      const values = [...new Set(this.cards.flatMap(card => card.data.variants.map(v => v[field])))];
      values.sort(field === 'size' ? sizeOrder : (a, b) => a.localeCompare(b, document.documentElement.lang));
      const select = this.form.elements.namedItem(field);
      for (const value of values) select.add(new Option(value, value));
    }
    const styles = new Set(this.cards.flatMap(card => card.data.styles || []));
    for (const option of [...this.form.elements.namedItem('style').options]) {
      if (option.value && !styles.has(option.value)) option.remove();
    }
    this.form.addEventListener('submit', event => event.preventDefault());
    this.form.addEventListener('change', () => this.update());
    this.form.addEventListener('reset', event => {
      event.preventDefault();
      for (const select of this.form.querySelectorAll('select')) select.selectedIndex = 0;
      this.update();
    });
    this.form.hidden = this.cards.length === 0;
    this.update();
  }

  update() {
    const filters = Object.fromEntries(new FormData(this.form));
    let count = 0;
    for (const card of this.cards) {
      const matches = matchesProduct(card.data, filters);
      card.element.hidden = !matches;
      if (matches) count++;
    }
    this.querySelector('[data-result-count]').textContent = this.dataset.countLabel.replace('__COUNT__', count);
    this.querySelector('[data-no-results]').hidden = count !== 0;
  }
}
if (!customElements.get('everytee-catalog')) customElements.define('everytee-catalog', EveryteeCatalog);
